import { Checkbox, FormControlLabel, Grid, MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Campo from "../Campo";

export const nombreComandera = (comandera) =>
  comandera ? `${comandera.printName || `Impresora #${comandera.id}`}${comandera.habilitado === false ? " (deshabilitada)" : ""}` : "";

export default function PasoCobro({ form, setField, errores, opciones, soloLectura }) {
  const medios = opciones?.mediosPago || [];
  const elegidos = form.mediosPago || medios.map((medio) => medio.codigo);
  const comanderas = opciones?.comanderas || [];
  const predeterminada = comanderas.find((item) => String(item.id) === String(opciones?.idComanderaPredeterminada));
  const elegida = comanderas.find((item) => String(item.id) === String(form.idComandera));
  // La guardada pudo eliminarse: se muestra igual para que el Select no quede
  // en blanco, y la validación del paso obliga a elegir otra.
  const noDisponible = Boolean(form.idComandera) && !elegida;

  const alternarMedio = (codigo, marcado) => {
    const siguiente = marcado ? [...elegidos, codigo] : elegidos.filter((item) => item !== codigo);
    // Todos marcados se guarda como "todos" (null).
    setField("mediosPago", siguiente.length === medios.length ? null : siguiente);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Campo label="Medios de pago" requerido error={errores.mediosPago}
          ayuda="El vendedor confirma cada cobro antes de cerrar la venta.">
          <SoftBox sx={{ display: "grid", gap: 1, gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 220px), 1fr))" }}>
            {medios.map((medio) => (
              <FormControlLabel key={medio.codigo}
                sx={{ m: 0, px: 1, py: 0.5, border: "1px solid", borderColor: elegidos.includes(medio.codigo) ? "#B5DED7" : "#E2E8F0", bgcolor: elegidos.includes(medio.codigo) ? "#F0F9F6" : "#fff", borderRadius: "10px", minHeight: 48 }}
                control={<Checkbox checked={elegidos.includes(medio.codigo)} disabled={soloLectura} onChange={(_, value) => alternarMedio(medio.codigo, value)} />}
                label={(
                  <SoftBox display="flex" alignItems="center" gap={1}>
                    <SoftTypography variant="button" fontWeight="bold">{medio.etiqueta}</SoftTypography>
                    {medio.recomendado && <SoftBadge color="uproGreen" badgeContent="Recomendado" size="xs" container />}
                  </SoftBox>
                )} />
            ))}
          </SoftBox>
        </Campo>
      </Grid>
      <Grid item xs={12} sm={8} md={6}>
        <Campo id="evento-comandera" label="Impresora de comandas"
          error={errores.idComandera || (elegida?.habilitado === false ? "La impresora está deshabilitada: elija otra o use la predeterminada." : null)}
          ayuda="Recibe los productos que no son del menú universitario.">
          <Select id="evento-comandera" value={form.idComandera} onChange={(e) => setField("idComandera", e.target.value)} displayEmpty fullWidth
            disabled={soloLectura} error={Boolean(errores.idComandera)}>
            <MenuItem value="">
              Predeterminada{predeterminada ? ` · ${nombreComandera(predeterminada)}` : ` (#${opciones?.idComanderaPredeterminada || "—"})`}
            </MenuItem>
            {noDisponible && (
              <MenuItem value={String(form.idComandera)} disabled>Impresora #{form.idComandera} (no disponible)</MenuItem>
            )}
            {comanderas.map((comandera) => (
              <MenuItem key={comandera.id} value={String(comandera.id)} disabled={comandera.habilitado === false}>
                {nombreComandera(comandera)}
              </MenuItem>
            ))}
          </Select>
        </Campo>
      </Grid>
    </Grid>
  );
}

PasoCobro.propTypes = {
  form: PropTypes.object.isRequired,
  setField: PropTypes.func.isRequired,
  errores: PropTypes.object.isRequired,
  opciones: PropTypes.object,
  soloLectura: PropTypes.bool,
};

PasoCobro.defaultProps = { soloLectura: false };
